import { Component, Input } from '@angular/core';
import { ExtendedDashboardTileViewModel } from '@modules/dashboard/models/extended-dashboard-tile-view-model';

@Component({
    selector: 'app-dashboard-single-group-tile-details-per-tile',
    templateUrl: './dashboard-single-group-tile-details-per-tile.component.html',
    styleUrls: ['./dashboard-single-group-tile-details-per-tile.component.scss']
})
export class DashboardSingleGroupTileDetailsPerTileComponent {
    @Input()
    public data?: ExtendedDashboardTileViewModel;
}
